module.exports = __webpack_public_path__ + "static/media/esam_profile.1c3104ff.jpg";